/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Common translation types for select component
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.0.0
 */

import ICommonTranslationSelect from '../../types/common/select';

const initTranslationSelect: ICommonTranslationSelect = {
    exist: '',
    noExist: '',
    placeholder: '',
    searchPlaceholder: '',
};

export default initTranslationSelect;
